import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { getIntlLocale } from "@/localization/constants";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const CURRENCY_CONFIG = {
  usd: {
    currency: "USD",
    labels: { en: "US Dollar", sk: "Americký dolár" },
  },
  eur: {
    currency: "EUR",
    labels: { en: "Euro", sk: "Euro" },
  },
  gbp: {
    currency: "GBP",
    labels: { en: "British Pound", sk: "Britská libra" },
  },
};

export function normalizeCurrencyCode(currency) {
  return String(currency ?? "").trim().toLowerCase();
}

export function formatCurrencyAmount(amount, currency, locale = "en") {
  const normalizedCurrency = normalizeCurrencyCode(currency);
  const config = CURRENCY_CONFIG[normalizedCurrency];

  if (!config || !Number.isFinite(Number(amount))) {
    return `${normalizedCurrency.toUpperCase() || "N/A"} ${Number(amount).toFixed(2)}`;
  }

  return new Intl.NumberFormat(getIntlLocale(locale), {
    style: "currency",
    currency: config.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function getCurrencyLabel(currency, locale = "en") {
  const normalizedCurrency = normalizeCurrencyCode(currency);
  const normalizedLocale = String(locale ?? "en").toLowerCase().startsWith("sk")
    ? "sk"
    : "en";
  return (
    CURRENCY_CONFIG[normalizedCurrency]?.labels?.[normalizedLocale] ??
    normalizedCurrency.toUpperCase()
  );
}

export function formatDateTime(value, locale = "en", options) {
  if (!value) {
    return "";
  }

  return new Intl.DateTimeFormat(getIntlLocale(locale), options).format(
    new Date(value),
  );
}
